<template>
    <v-container fluid>
        <v-card
            class="mx-auto"
            max-width="300"
        >
            <v-card-title
                class="secondary--text primary"
            >
                Reports
            </v-card-title>
            <v-list>                
                <v-list-item-group color="primary">
                    <div v-for="(report, i) in reports" :key="i">
                        <v-list-item                            
                            @click="displayReportMenu(report)"
                        >
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ report.title }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider
                            v-if="i < reports.length - 1"
                            :key="i"
                        >                        
                        </v-divider>
                    </div>
                    
                </v-list-item-group>
            </v-list>
        </v-card>

        <v-dialog
            v-model="dialog"
            max-width="90vw"
            persistent            
        >
            <v-card height="80vh">
                <iframe 
                    ref="pdf" 
                    style="width:100%; height:100%" 
                    frameBorder="0" 
                    :src="src"
                ></iframe>

                <v-overlay
                    absolute
                    :value="overlayReport"
                    color="white"
                    opacity="0.60"
                >
                    <v-progress-circular
                        indeterminate
                        size="64"
                        color="primary"
                    ></v-progress-circular>
                </v-overlay>

                <v-overlay
                    :absolute="absolute"
                    :value="overlay"
                    opacity="0.5"
                    color="#A0A0A0"
                >
                    <v-card                        
                        light
                        max-width="380"
                        class="pa-4"
                    >
                        <v-card-title>
                            {{ cardTitle }}
                        </v-card-title>

                        <v-card-text
                            v-if="menu.studentSubject" 
                        >
                            <v-row>
                                <v-col cols="12">
                                    <v-autocomplete
                                        v-model="selectedFormLevel"
                                        :items="formLevelsUpperSchool"
                                        label="Select Form"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12">
                                    <v-autocomplete
                                        v-model="selectedSubjectId"
                                        :items="subjects"
                                        item-text="title"
                                        item-value="id"
                                        label="Select Subject"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-card-text>

                        <v-card-text
                            v-if="menu.reportCardAccess" 
                        >
                             <v-row>
                                <v-col 
                                    cols="12"                                    
                                >
                                    <v-autocomplete
                                        v-model="selectedFormLevel"
                                        :items="formLevels"
                                        label="Select Form"
                                        chips                                        
                                        dense
                                        hide-details
                                        @change="setFormClasses"                                       
                                    >
                                        <template v-slot:selection="data">
                                            <v-chip
                                                v-bind="data.attrs"
                                                :input-value="data.selected"
                                                close
                                                @click:close="clearFormLevel"                                                
                                            >
                                                {{ data.item}}
                                            </v-chip>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col 
                                    cols="12"                                    
                                >
                                    <v-autocomplete
                                        v-model="selectedClassId"
                                        :items="formClasses"                                        
                                        label="Select Class"
                                        chips                                        
                                        dense
                                        hide-details
                                    >
                                        <template v-slot:selection="data">
                                            <v-chip
                                                v-bind="data.attrs"
                                                :input-value="data.selected"
                                                close
                                                @click:close="clearClassId"                                                
                                            >
                                                {{ data.item}}
                                            </v-chip>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col 
                                    cols="12"                                    
                                >
                                    <v-autocomplete
                                        v-model="selectedTerm"
                                        :items="terms"                                        
                                        label="Select Term"
                                        item-text="title"
                                        chips
                                        deletable-chips
                                        dense
                                        hide-details
                                        return-object
                                    ></v-autocomplete>
                                </v-col>
                                <v-col
                                    cols="12"
                                >
                                   <date-picker-range
                                        label="Select Date Range"
                                        v-on:update-range="setDateRange"
                                        :selectedDate="dateRange"
                                   ></date-picker-range>
                                </v-col>
                            </v-row>  
                        </v-card-text>

                        <v-card-text
                            v-if="menu.failedLogins"
                        >
                            <v-row>
                                <v-col
                                    cols="12"
                                >
                                   <date-picker-range
                                        label="Select Date Range"
                                        v-on:update-range="setDateRange"
                                        :selectedDate="dateRange"
                                   ></date-picker-range>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        

                        <v-card-actions>
                            
                            <v-btn
                                color="primary"
                                outlined
                                @click="closeReportMenu"
                                class="mr-2 flex-grow-1"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                color="primary"
                                dark
                                @click="displayReport"
                            >
                                Display Report
                            </v-btn>
                        </v-card-actions>

                         <v-overlay
                            :absolute="absolute"
                            :value="overlayLoading"                    
                            color="grey lighten-5"
                            opacity="0.9"
                            class="pa-5"
                        > 
                            <v-progress-circular
                                indeterminate 
                                size="64"                            
                                color="primary"                                
                            ></v-progress-circular>                   
                        </v-overlay>
                    </v-card>

                </v-overlay>                             
            </v-card>

            <v-container
                fluid
                class="pa-0"
                v-if="!overlay"
            >
                <v-sheet>
                    <v-row
                        justify="end"
                        class="ma-0"
                    >
                        <v-btn
                            color="primary"
                            small
                            dark
                            @click="closeReport"
                            class="my-2 mr-4"
                        >
                            Close
                        </v-btn>
                    </v-row>
                </v-sheet>
            </v-container>
           
        </v-dialog>
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DatePickerRange from './DatePickerRange'
import axios from 'axios';

export default {
    components: {
        DatePickerRange,
    },

    mounted: function () {
        this.initialize();
    },

    computed: {
       ...mapGetters({
           authToken: 'auth/getAuthToken',
       })   
    },
    
    data: () => ({
        reports: [
            {id: 1, title: "Student by Class/Subject", value: 'studentSubject', menu: true},
            {id: 2, title: "E-Report Student Access Logs", value: 'reportCardAccess', menu: true},
            {id: 3, title: "Logins - Students Failed Logins", value: 'failedLogins', menu: true},
            {id: 4, title: "Logins - Students Never Logged In", value: 'studentsNoLogins', menu: false},
        ],
        dialog: false,
        src: '',
        absolute: true,
        overlay: false,
        overlayLoading: false,
        cardTitle: '',        
        formLevels: [],
        formLevelsUpperSchool: [],
        selectedFormLevel: 0,
        selectedSubjectId: null,
        subjects: [],
        selectedReport: null,
        menu: {},        
        formClassesRecords: [],
        formClasses: [],
        selectedClassId: 0,
        terms: [],
        selectedTerm: {},
        dateRange: [],
        overlayReport: false
    }),

    watch: {
        dateRange: {
            handler (val) {
                console.log(val);
            }
        }
    },

    methods: {
        ...mapActions({
            getFormLevels: 'admin/getFormLevels',
            getSubjects: 'admin/getSubjects',
            getFormClasses: 'admin/getFormClasses',
            getReportsPosted: 'admin/getReportsPosted',
        }),

        async initialize () {
            console.log("initializing");
            let response = null;
            this.overlayLoading = true;
            try {
                const formLevelsPromise = this.getFormLevels();
                const subjectsPromise = this.getSubjects();
                const formClassesPromise = this.getFormClasses();
                const reportsPostedPromise = this.getReportsPosted();

                response = await formLevelsPromise;
                response.data.forEach(value => {
                    if(value.form_level > 3)
                    this.formLevelsUpperSchool.push(value.form_level);
                    this.formLevels.push(value.form_level);
                })

                response = await subjectsPromise;
                this.subjects = response.data;

                response = await formClassesPromise;
                this.formClassesRecords = response.data;
                response.data.forEach(record => {
                    if(record.form_level)
                    this.formClasses.push(record.id);
                })
                
                response = await reportsPostedPromise;
                response.data.forEach(record => {
                    this.terms.push({
                        title: record.year + ' Term ' + record.term,
                        year: record.year,
                        term: record.term 
                    })
                })
                // console.log(response);

            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }

            // this.reports.forEach(item => {
            //     this.menu[item.value] = false;
            // })

            this.overlayLoading = false;
        },

        displayReportMenu (report) {
            // console.log(report.value);            
            this.overlay = true;
            // this.clearMenu();
            this.selectedReport = report;
            this.selectedTerm = {
                year: 0,
                term: 0
            }

            this.reports.forEach(item => {                
                if(item.value == report.value){
                    if(item.menu){
                        this.cardTitle = item.title;
                        this.menu[item.value] = true;
                    }
                    else{
                        this.displayReport();
                    }                    
                    
                }
                // else if(!item.menu){
                //     console.log(`Menu: ${item.menu}`)
                //     this.displayReport();
                // }
                else{
                    console.log("item false");
                    this.menu[item.value] = false;
                }                 
                
            })

            this.dialog = true;           
            // console.log(this.menu);
        },

        clearMenu () {
            Object.keys(this.menu).forEach(key => {
                this.menu[key] = false;
            })
        },

        displayReport () {
            const baseUrl = process.env.VUE_APP_API_URI  + 'api/';
            let src = null;
            this.overlayReport = true;
            switch (this.selectedReport.value) {
                case "studentSubject":                    
                    src = baseUrl + "student-subject-report/" +
                    this.selectedFormLevel + "/" +
                    this.selectedSubjectId;
                    break;
                case "reportCardAccess":
                    src = baseUrl + "report-card-access-logs/" +
                    this.selectedTerm.year + "/" +
                    this.selectedTerm.term + "/" +
                    this.selectedFormLevel + "/" + 
                    this.selectedClassId + "/" +
                    this.dateRange.join("/");
                    // console.log(this.src);
                    break;
                case "failedLogins":
                    src = baseUrl + "report-failed-logins/" +
                    this.dateRange.join("/");
                    break;
                case "studentsNoLogins":
                    src = baseUrl + "no-logins-student";
                    break;            
            }
            
            axios.get(
                src,
                {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.authToken,
                        Accept: 'application/pdf'
                        }
                    }
            )
            .then(response => {
                const file = new Blob(
                    [response.data],
                    { type: 'application/pdf' }
                );
                this.src = URL.createObjectURL(file);
                this.overlayReport = false;
            }) 
            .catch(error => {
                if(error.response) console.log(error.response);
                else console.log(error);
                this.overlayReport = false;
            }) 

            this.overlay = false;
        },

        closeReportMenu () {
            this.dialog = false;
            this.src = '';
            this.selectedReport = null;
            this.selectedSubjectId = null;
            this.selectedFormLevel = null;
        },

        closeReport () {
            if(this.selectedReport.menu){
                this.overlay = true; 
                this.src = '';               
            }
            else this.closeReportMenu();
            // console.log(this.dateRange);
        },

        setDateRange (dates) {            
            this.dateRange = dates;
        },

        setFormClasses () {
            if(this.selectedFormLevel){
                this.formClasses = [];
                this.formClassesRecords.filter(record => {
                    if(record.form_level == this.selectedFormLevel)
                    this.formClasses.push(record.id);
                })
                // console.log(test);
            }
            else{
                console.log('no selected form level');
                this.selectedFormLevel = 0;
                console.log(this.formClassesRecords);
                // this.formClasses = this.formClassesRecords.forEach(record => {
                //     this.formClasses.push(record.id);
                // })                                
            }
        },

        clearFormLevel () {
            console.log("form level cleared");
            this.selectedFormLevel = 0;
            // console.log(this.formClasses);
            let formClasses = [];
            this.formClassesRecords.forEach(record => {
                if(record.form_level)
                formClasses.push(record.id);
            })
            // console.log(formClasses);
            this.formClasses = formClasses;
        },

        clearClassId () {
            this.selectedClassId = 0;
        }
    }
}
</script>